<div class="loading-container">
  <ish-account-addresses [error]="(errorAddresses$ | async) || (errorUser$ | async)" />

  <ish-loading *ngIf="loading$ | async" />
</div>
